<template>
    <div class="card">
        <div class="card-body">
            <a class="btn btn-info mb-3 float-right ml-2" href="/report"><i class="fa fa-angle-left" aria-hidden="true"></i> Back</a>
            <button @click.prevent="download()" class="btn btn-success mb-3 float-right">Download</button>
            <div class="clearfix"></div>
            <div class="content">
                <div class="content_header">
                    <h3>চাঁদপুর পৌরসভা</h3>
                    <h4>মার্কেট অনুসারে দোকানের সংখ্যা</h4>
                </div>
                <table class="table table-sm">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>মার্কেটের নাম</th>
                            <th>দোকান সংখ্যা</th>
                            <th>পার্চেন্ট</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(val,key) in data" :key="key">
                            <td>{{ key+1}}</td>
                            <td>{{ val.market_name}}</td>
                            <td>{{ val.dokan_no}}</td>
                            <td>{{ val.percent}}%</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td><b>মোট</b></td>
                            <td><b>{{ data[0].total_markets}}</b></td>
                            <td><b>100%</b></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import axios from 'axios';
import { mapGetters } from "vuex"
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

export default {
    name: "MarketWiseShop",
    data(){
        return {
            data:{},
        }
    },
    methods:{
        async getResults(){
            axios.get('/api/market-wise-shop').then(response=>{
                this.data = response.data;
                //console.log(this.data);
            })
        },
        download(){
            var download = 'download'
            let getUserInfo = JSON.parse(localStorage.getItem('user'))
            let loggedUser = getUserInfo.name

            window.open(`${axios.defaults.baseURL}/api/market-wise-shop?download=${download}&loggeduser=${loggedUser}`)

        },
    },
    mounted(){
        this.getResults()
    },
    computed:{
    },
    components: {

    }
}
</script>
<style scoped>
.content_header{ text-align: center; border:1px solid #999; padding:10px; margin-bottom: 15px; background: #f7f7f7;}
.content_header h3{ font-size: 20px;font-family: 'Kalpurush', Arial, sans-serif !important; margin:0;}
.content_header h4{ font-size: 16px;font-family: 'Kalpurush', Arial, sans-serif !important; margin:0;}
table{ border: 1px solid #999;font-family: 'Kalpurush', Arial, sans-serif !important;}
table th, td{ border: 1px solid #999;}
table thead tr th,table thead tr td{ text-align: center;}
table tbody tr:last-child td{ border:0; background: #f7f7f7;}
table thead tr th{ background: #f7f7f7;}
.clearfix{ clear: both;}
.btn-info{ color: #fff; text-transform: capitalize;}
</style>
